import { PagerDtoRequest } from 'src/app/_models/messaging/pager-dto-request';

export class DetailedEmailReportRequest {
    pager: PagerDtoRequest;
    reportId: number;
    filter: string;
    emailFilter:string;

    constructor({ pagerDtoRequest, reportId, filter , emailFilter}:
        { pagerDtoRequest: PagerDtoRequest; reportId: number; filter: string; emailFilter: string}) {                    
        this.reportId = reportId;
        this.filter = filter;
        this.emailFilter = emailFilter;
        this.pager = pagerDtoRequest;
    }
}
